export default {
  errorBoundaries: {
    title: 'Oops! Something went wrong.',
    message: 'Please try again later',
    primaryButtonExitApp: 'Exit app',
    primaryButtonDone: 'Done',
    secondaryButtonLogout: 'Logout',
  },
  walletPay: {
    successScreen: {
      title: '{{amount}} AVAILABLE NOW',
      eyebrowText: 'SUCCESS',
      subtitle: 'Your money is now in your bank account.',
      buttons: {
        done: 'Done',
      },
    },
    errorScreen: {
      done: 'Done',
      headline: 'Error',
      body: 'An unexpected error occurred.',
    },
  },
};
